import React from "react";
import PageWrapper from "./Rd.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import RdTable from "../../components/rd/RdTable";

const Rd = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.provider"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/dashboard"
          },
          {
            name: "sidebar.provider"
          }
        ]}
      />
      <div className="user-tbl">
        <RdTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.permissionReducer,
    ...state.themeChanger,
    authData: {
      token: state.auth.token,
      isLogin: state.auth.isLogin,
      profileImage: state.auth.profile_image,
      adminRoleId: state.auth.admin_role_id,
      adminRole: state.auth.admin_role,
      full_name: state.auth.first_name + " " + state.auth.last_name,
      practice: state.auth.practice,
      service: state.auth.service_id
    }
  };
};

export default connect(mapStateToProps, null)(Rd);
